/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";

const folders = {
  ProductInfoSideBar: import.meta.glob('@/components/Custom/ProductInfoSideBar/*.tsx'),
  BrandLogo: import.meta.glob('@/components/Custom/BrandLogo/*.tsx'),
  AddProductButton: import.meta.glob('@/components/Custom/AddProductButton/*.tsx'),
  DesktopCarousel: import.meta.glob('@/components/Custom/DesktopCarousel/*.tsx'),
  MobileCarousel: import.meta.glob('@/components/Custom/MobileCarousel/*.tsx'),
  Footer: import.meta.glob('@/components/Custom/Footer/*.tsx'),
  DesktopBrandLogo: import.meta.glob('@/components/Custom/DesktopBrandLogo/*.tsx'),
  Header: import.meta.glob('@/components/Custom/Header/*.tsx'),
  ProductsCarousel: import.meta.glob('@/components/Custom/ProductsCarousel/*.tsx'),
};

type GetCustomComponentProps = {
  brandName: string;
  folder: keyof typeof folders;
}

export const getCustomComponent = ({ folder, brandName, }: GetCustomComponentProps) => {
  const modules = folders[folder as keyof typeof folders];

  const hostMap: Record<string, () => Promise<{ default: React.ComponentType<any> }>> = {};

  for (const path in modules) {
    // extract host from path
    const match = path.match(new RegExp(`${folder}/([^/]+)\\.tsx$`));

    if (match) {
      const hostKey = match[1];
      hostMap[hostKey] = modules[path] as () => Promise<{ default: React.ComponentType<any> }>;
    }
  }

  const hostKey = brandName.toLocaleLowerCase().replace(/\s+/g, '');
  const LazyComponent = hostMap[hostKey]
    ? React.lazy(hostMap[hostKey])
    : React.lazy(hostMap['default']);

  return LazyComponent;
}